/* ============================================================================
   mobile.js — Enrichissements MOBILE Orak (refonte mobile)
   ----------------------------------------------------------------------------
   Chargé EN DERNIER, en defer. RÈGLE ABSOLUE : le DESKTOP ne doit JAMAIS être
   modifié.
   → Tout le scaffolding mobile est CRÉÉ en JS uniquement sous 768px, et RETIRÉ
     (teardown) dès qu'on repasse au-dessus : les noeuds d'origine sont remis à
     leur place EXACTE (placeholders), aucun résidu en desktop. Le .liquid n'est
     pas touché : sur desktop, ni le markup ni le DOM ne changent.
   Breakpoint unique de la refonte : 768px.

   MODULE : Drawer filtres boutique (Section B)
   ----------------------------------------------------------------------------
   On DÉPLACE les vrais noeuds filtres (#searchBar, #advFilters, .sort-select)
   dans un bottom-sheet créé en JS, en préservant id/onclick → toggleAdvFilters,
   applyAllClientFilters, recherches sauvegardées, persistance URL et scroll
   infini continuent de fonctionner à l'identique. Barre sticky « Filtrer /
   Trier / X lots » au-dessus de la grille. Footer « Effacer / Enregistrer /
   Voir X lots ». Les filtres s'appliquent en direct (client) ; le compteur
   #countNum est reflété en live sur la barre et le bouton « Voir ».
   ============================================================================ */
(function () {
  var MQ = window.matchMedia('(max-width: 768px)');
  var ROOT = document.documentElement;

  // Références des noeuds déplacés + leur placeholder (pour restauration exacte).
  var MOVED = {};
  // Éléments créés par le module (à supprimer au teardown).
  var CREATED = { bar: null, drawer: null };
  var countObserver = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }

  function detach(node, key) {
    if (!node) return null;
    var ph = document.createComment('m-slot:' + key);
    node.parentNode.insertBefore(ph, node);
    MOVED[key] = { node: node, ph: ph };
    return node;
  }
  function reattachAll() {
    Object.keys(MOVED).forEach(function (key) {
      var e = MOVED[key];
      if (e && e.ph && e.ph.parentNode) e.ph.parentNode.replaceChild(e.node, e.ph);
      else if (e && e.ph && e.ph.remove) e.ph.remove();
    });
    MOVED = {};
  }

  function currentCount() {
    var n = $('#countNum');
    return n ? (n.textContent || '').trim() : '';
  }
  function currentBadge() {
    var b = $('#advBadge');
    if (!b || b.hasAttribute('hidden')) return '';
    var v = (b.textContent || '').trim();
    return (v && v !== '0') ? v : '';
  }
  function syncCounts() {
    var c = currentCount(), badge = currentBadge();
    var barC = CREATED.bar && CREATED.bar.querySelector('.m-fbar-count strong');
    if (barC) barC.textContent = c;
    var applyC = CREATED.drawer && CREATED.drawer.querySelector('.m-drw-apply strong');
    if (applyC) applyC.textContent = c;
    var badgeEl = CREATED.bar && CREATED.bar.querySelector('.m-fbar-badge');
    if (badgeEl) {
      if (badge) { badgeEl.textContent = badge; badgeEl.hidden = false; }
      else { badgeEl.hidden = true; }
    }
  }

  function openDrawer(mode) {
    if (!CREATED.drawer) return;
    mode = (mode === 'sort') ? 'sort' : 'filter';
    CREATED.drawer.dataset.mode = mode;
    var title = CREATED.drawer.querySelector('.m-drw-title');
    if (title) title.textContent = (mode === 'sort') ? 'Trier par' : 'Filtres';
    CREATED.drawer.hidden = false;
    // reflow avant l'ajout de la classe → transition d'entrée.
    void CREATED.drawer.offsetWidth;
    CREATED.drawer.classList.add('is-open');
    ROOT.classList.add('m-drawer-lock');
    syncCounts();
  }
  function closeDrawer() {
    if (!CREATED.drawer) return;
    CREATED.drawer.classList.remove('is-open');
    ROOT.classList.remove('m-drawer-lock');
    var d = CREATED.drawer;
    setTimeout(function () { if (d && !d.classList.contains('is-open')) d.hidden = true; }, 260);
  }

  function build() {
    if (ROOT.dataset.mDrawer === '1') return;
    var section = $('.products-section');
    var searchBar = $('#searchBar');
    var advFilters = $('#advFilters');
    var sortSelect = $('.sort-select');
    // Le drawer n'a de sens que sur une page collection avec ces éléments.
    if (!section || !searchBar || !advFilters) return;

    ROOT.dataset.mDrawer = '1';

    // ── Barre sticky « Filtrer / Trier / X lots » ──
    var bar = document.createElement('div');
    bar.className = 'm-fbar';
    bar.innerHTML =
      '<button type="button" class="m-fbar-btn m-fbar-filter" aria-haspopup="dialog">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/></svg>' +
        '<span>Filtrer</span><span class="m-fbar-badge" hidden></span>' +
      '</button>' +
      '<button type="button" class="m-fbar-btn m-fbar-sort" aria-haspopup="dialog">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h12M3 12h9M3 18h6"/><path d="M17 8V4m0 0l-2.5 2.5M17 4l2.5 2.5"/></svg>' +
        '<span>Trier</span>' +
      '</button>' +
      '<span class="m-fbar-count"><strong></strong> lots</span>';
    section.parentNode.insertBefore(bar, section);
    CREATED.bar = bar;

    // ── Bottom-sheet ──
    var drawer = document.createElement('div');
    drawer.className = 'm-drw';
    drawer.hidden = true;
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.innerHTML =
      '<div class="m-drw-scrim" data-close></div>' +
      '<div class="m-drw-sheet">' +
        '<div class="m-drw-head">' +
          '<span class="m-drw-title">Filtres</span>' +
          '<button type="button" class="m-drw-x" data-close aria-label="Fermer">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="m-drw-body"></div>' +
        '<div class="m-drw-foot">' +
          '<button type="button" class="m-drw-clear">Effacer</button>' +
          '<button type="button" class="m-drw-save">Enregistrer</button>' +
          '<button type="button" class="m-drw-apply">Voir <strong></strong> lots</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(drawer);
    CREATED.drawer = drawer;

    var body = drawer.querySelector('.m-drw-body');

    // Deux panneaux distincts : « Filtrer » ≠ « Trier ».
    var panelFilter = document.createElement('div');
    panelFilter.className = 'm-drw-panel m-drw-panel-filter';
    var panelSort = document.createElement('div');
    panelSort.className = 'm-drw-panel m-drw-panel-sort';
    body.appendChild(panelFilter);
    body.appendChild(panelSort);

    // ── Panneau FILTRES : les vrais noeuds déplacés (placeholders → restauration) ──
    panelFilter.appendChild(detach(searchBar, 'searchBar'));
    panelFilter.appendChild(detach(advFilters, 'advFilters'));

    // Claviers natifs corrects sur les champs texte.
    var kw = $('#keyword'); if (kw) kw.setAttribute('inputmode', 'text');
    var surf = $('#surface'); if (surf) surf.setAttribute('inputmode', 'numeric');

    // ── Panneau TRIER : liste d'options générée depuis le .sort-select réel ──
    if (sortSelect) {
      panelSort.appendChild(detach(sortSelect, 'sortSelect'));   // conservé (caché) → handleSort + persistance de valeur
      var list = document.createElement('div');
      list.className = 'm-drw-sortlist';
      Array.prototype.forEach.call(sortSelect.options, function (opt) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'm-drw-sortopt';
        b.dataset.value = opt.value;
        b.textContent = opt.textContent;
        if (opt.value === sortSelect.value) b.classList.add('is-active');
        b.addEventListener('click', function () {
          sortSelect.value = opt.value;
          if (typeof window.handleSort === 'function') window.handleSort(opt.value);
          list.querySelectorAll('.m-drw-sortopt').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          closeDrawer();
        });
        list.appendChild(b);
      });
      panelSort.appendChild(list);
    }

    // ── Câblage ──
    bar.querySelector('.m-fbar-filter').addEventListener('click', function () { openDrawer('filter'); });
    bar.querySelector('.m-fbar-sort').addEventListener('click', function () { openDrawer('sort'); });
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-close]'), function (el) {
      el.addEventListener('click', closeDrawer);
    });
    // Effacer → réutilise la logique existante (navigation vers URL nettoyée).
    drawer.querySelector('.m-drw-clear').addEventListener('click', function () {
      if (typeof window.clearAllFilters === 'function') window.clearAllFilters();
      else { var b = $('#clearFiltersBtn'); if (b) b.click(); }
    });
    // Enregistrer → ouvre la modale « recherche sauvegardée » existante.
    drawer.querySelector('.m-drw-save').addEventListener('click', function () {
      if (typeof window.openModal === 'function') window.openModal();
    });
    // Voir X lots → applique les champs texte (marque/surface) via runSearch puis ferme.
    drawer.querySelector('.m-drw-apply').addEventListener('click', function () {
      if (typeof window.runSearch === 'function') window.runSearch();
      closeDrawer();
    });

    // ── Compteur live : refléter #countNum sur la barre + le bouton « Voir ». ──
    var countNode = $('#countNum');
    if (countNode && window.MutationObserver) {
      countObserver = new MutationObserver(syncCounts);
      countObserver.observe(countNode, { childList: true, characterData: true, subtree: true });
    }
    syncCounts();
  }

  function teardown() {
    if (ROOT.dataset.mDrawer !== '1') return;
    if (countObserver) { countObserver.disconnect(); countObserver = null; }
    ROOT.classList.remove('m-drawer-lock');
    reattachAll();                                   // remet searchBar/advFilters/sortSelect à leur place exacte
    if (CREATED.bar && CREATED.bar.remove) CREATED.bar.remove();
    if (CREATED.drawer && CREATED.drawer.remove) CREATED.drawer.remove();
    CREATED.bar = null; CREATED.drawer = null;
    delete ROOT.dataset.mDrawer;                     // DOM desktop restauré à l'identique
  }

  function sync() { if (MQ.matches) build(); else teardown(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  if (MQ.addEventListener) MQ.addEventListener('change', sync);
  else if (MQ.addListener) MQ.addListener(sync);     // Safari ancien
})();
